import { LicenseTester, StringUtil } from "@mcleod/core";
import {
    DataSourceMode, DataSourceModeChangeEvent, DropdownItem, LookupModelSearchEvent, ValidationResult
} from "@mcleod/components";
import { AutogenLayoutOrderPayablesProfile } from "./autogen/AutogenLayoutOrderPayablesProfile";
import { GroupByItems } from "./OrderPayablesGroupByTable";
import { DuplicateId } from "@mcleod/dispatch/src/DuplicateId";

export class OrderPayablesProfile extends AutogenLayoutOrderPayablesProfile {
    onLoad(): void | Promise<void> {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
        this.sourceOrderPayablesProfile.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            const isContractTransferLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.ifuel");
            if (event.newMode == DataSourceMode.SEARCH && !isContractTransferLicensed) {
                this.textboxPaymentMethod.removeItemsWithValue("T");
            } else if ((event.newMode == DataSourceMode.UPDATE || event.newMode == DataSourceMode.ADD) && !this.activeRow.getBoolean("is_contract_transfer", false)) {
                this.textboxPaymentMethod.removeItemsWithValue("T");
            }
            if (!this.activeRow.getBoolean("triumphpay_active", false)) {
                this.textboxPaymentMethod.removeItemsWithValue("U");
            }
            this.textboxPaymentMethod.displayComponentData(this.activeRow, null, 0);
        });
        this.textboxGroupByDefault.items = GroupByItems.map(item => new DropdownItem(item.value, item.displayValue));
        this.textboxDepartment.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.departmentValidator(this.textboxDepartment.text, mode);
        };
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "order_payables_profile",
            screenName: "Order Payables Profile",
            navigateToUrl: "lme/settlement/OrderPayablesProfile?mode=update&key="
        });
    }

    private departmentValidator(department: string, mode: DataSourceMode): ValidationResult {
        if (mode === DataSourceMode.SEARCH) {
            return null;
        }
        const result: ValidationResult = {
            component: this.textboxDepartment,
            isValid: true
        }
        const regex = /^([ 0-9a-zA-Z]{1,3},)*[ 0-9a-zA-Z]{1,3}$/;
        if (!StringUtil.isEmptyString(department) && !regex.test(department)) {
            result.isValid = false;
            result.validationMessage = "Please enter departments (up to 3 characters) delimited by commas.";
        }
        return result;
    }

    textboxPayeeIdsBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter["drs_payee.type_of"] = "in A,R"
    }

    textboxReasonCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.code_type = "S";
    }
}
